import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import httpRequest from "../utils/httpRequest";

const AuthForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await httpRequest("auth/login", "POST", { email, password });
      setMsg("Login successful!");
      localStorage.setItem("token", data.token);
      navigate("/");

      setError(false);
    } catch (err) {
      setMsg(err?.response?.data?.message || "Something went wrong");
      setError(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #ece9e6, #ffffff)",
        px: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 400,
          width: "100%",
          p: 4,
          borderRadius: 4,
          backdropFilter: "blur(10px)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          bgcolor: "rgba(255,255,255,0.8)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Typography variant="h4" align="center" fontWeight={700} mb={1} color="primary">
          Welcome Back
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" mb={3}>
          Sign in with your admin credentials.
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ gap: 2, display: "flex", flexDirection: "column" }}
        >
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 1,
              fontWeight: 600,
              letterSpacing: 1,
              py: 1.2,
              borderRadius: 2,
            }}
          >
            Login
          </Button>
        </Box>

        {msg && (
          <Alert severity={error ? "error" : "success"} sx={{ mt: 2 }}>
            {msg}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default AuthForm;
